<template>
  <div class="popup-generic">
    <div class="popup-generic__icon" v-if="currentPopupOptions.icon">
      <img src="@/assets/icons/fail-icon.svg" alt="" v-if="currentPopupOptions.icon === 'error'" />
      <img
        src="@/assets/icons/success-icon.svg"
        alt=""
        v-if="currentPopupOptions.icon === 'success'"
      />
    </div>
    <h5
      class="popup-generic__icon-title"
      :class="`popup-generic__icon-title--${currentPopupOptions.icon}`"
      v-if="currentPopupOptions.iconTitle"
    >
      {{ currentPopupOptions.iconTitle }}
    </h5>
    <div class="popup-generic__content">
      <slot name="content"></slot>
    </div>
    <div class="popup-generic__button-wrapper" v-if="currentPopupOptions.actionCallback">
      <button
        @click.prevent="currentPopupOptions.actionCallback()"
        class="popup-generic__button button button--large button--primary button--full-width"
      >
        {{ currentPopupOptions.actionTitle }}
      </button>
    </div>
  </div>
</template>

<script src="./generic.js"></script>
<style src="./generic.scss" lang="scss"></style>
